jQuery(document).ready(function($) {

    loadIcons();
    $(document).on('click','[data-dismiss="floating-cta"]',function(e) {
        e.preventDefault();
        $(this).closest('.cta-floating').addClass('dismissed');
        create_cookie('notice-dismissed','dismissed',900);
    });
});
var icons = {
    search: 'search.svg',
    application: 'application.svg',
    play: 'play-circle.svg',
    account: 'account.svg',
    arrow: 'arrow.svg',
    menu: 'menu.svg',
    close: 'close.svg',
    'close-box': 'close-box.svg',
    linkedin: 'linkedin.svg',
    quote: 'logo-device.svg',
};
var themeBasePath = jQuery('meta[name=theme-base-path]').attr('content')+'/';
var loadedIcons = {};
function loadIcons(forceLoad = false) {
    var $ = jQuery;

    $('blockquote.with-quotes').each(function() {
        if ($(this).find('.icon').length)
            return true;
        $(this).prepend('<div class="icon icon-quote icon-open-quote" data-icon="quote"></div>');
        $(this).append('<div class="icon icon-quote icon-close-quote" data-icon="quote"></div>');
    });

    $('.cta-floating').each(function() {
        if (!$(this).find('.close-btn').length)
            $(this).prepend('<a href="#" class="close-btn" data-dismiss="floating-cta"><div class="icon icon-close" data-icon="close"></div></a>');
        if (!$(this).find('.cta-wrap-inner').length)
            $('.cta-floating').html('<div class="cta-wrap-inner">'+$('.cta-floating').html()+'</div>');
    });

    $('.icon').each(function() {
        var curIcon = $(this).data('icon');
        if (!icons[curIcon])
            return true;
        if ((forceLoad && loadedIcons[curIcon] != 'loading') || !loadedIcons[curIcon])
        {
            loadedIcons[curIcon] = 'loading';
            $.ajax(themeBasePath+'dist/img/'+icons[curIcon],{
                dataType: 'text',
                success: function(data) {
                    $('[data-icon='+curIcon+']').html(data);
                    loadedIcons[curIcon] = data;
                }
            });
        }
    });
}